import { AxiosResponse } from 'axios';

import API from '../api';

const ROUTE_NAME = 'videosurvey'

const VideoSurveyService = {
  async enter(videoSurvey: any): Promise<AxiosResponse<any>> {
    return await API.post(`/${ROUTE_NAME}/rooms/enter`, videoSurvey);
  },
};

export default VideoSurveyService;